import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";
import { api } from "@/lib/api";
import { BookCard, Carousel, SectionHeader } from "@/components/cards";

export default function RecRow({ endpoint, title, personalTitle, icon = Sparkles, testid, compact = false }) {
  const [data, setData] = useState(null);
  useEffect(() => { api.get(endpoint).then((r) => setData(r.data)).catch(() => setData(null)); }, [endpoint]);
  if (!data?.books?.length) return null;
  const heading = data.mode === "personal" && personalTitle ? personalTitle : title;
  return (
    <section data-testid={testid}>
      <SectionHeader icon={icon} title={heading} />
      <Carousel testid={`${testid}-carousel`}>
        {data.books.map((b) => (
          <div key={b.id} className={`${compact ? "w-36 md:w-40" : "w-40 md:w-48"} shrink-0 snap-start`} data-testid={`${testid}-item-${b.slug}`}>
            <BookCard book={b} />
            {b.rec_reason && <p className="text-[11px] text-primary/90 mt-1.5 truncate" title={b.rec_reason}>{b.rec_reason}</p>}
          </div>
        ))}
      </Carousel>
    </section>
  );
}
